export default __webpack_public_path__ + "static/media/register-v2.24c0a62e.svg";